module.exports = __webpack_public_path__ + "static/media/os.ccea0596.png";